import { selectFilteredSitesSelector } from './../features/sites/sitesAPI';
import { useGetSitesQuery } from '@features/sites/sitesAPI';
import { useAppSelector } from '../app/hooks';
import {
  selectSiteList,
  selectFilteredSiteList,
} from '@features/auth/authSlice';
import { useMemo } from 'react';

type CustomListArgs = {
  customList: number | number[];
  showAll?: never;
};

type ShowAllArgs = {
  customList?: never;
  showAll: true;
};

type Args = CustomListArgs | ShowAllArgs;

export default function useGetSites(args?: Args) {
  const { customList, showAll } = args
    ? args
    : { customList: undefined, showAll: undefined };
  const siteList = useAppSelector(selectSiteList);
  const filteredSiteList = useAppSelector(selectFilteredSiteList);
  const filterList = useMemo(() => {
    if (customList) {
      if (typeof customList === 'number') return [customList];
      return customList;
    }
    return filteredSiteList;
  }, [customList, filteredSiteList]);

  const { data, isLoading, isFetching, isError, error } = useGetSitesQuery(
    { store_list: siteList },
    {
      refetchOnMountOrArgChange: 300,
      pollingInterval: 600000, // 600000
      selectFromResult: showAll
        ? undefined
        : (result) => ({
            ...result,
            data: selectFilteredSitesSelector(result, filterList),
          }),
    },
  );

  return { data, isLoading, isFetching, isError, error };
}
